import React, { useEffect } from 'react';
import { startCase } from 'lodash';

import { SORT_OPTIONS } from '../utils/hooks/useSort';
import FiltersComponent from '../utils/filters';
import { Filter, MultiSelectFilter, TextFilter, NumberFilter } from '../utils/FilterTypes';
import { MobileDeviceStatuses, ApkType } from './mobileDevices';

interface Props {
    sortOptions: SORT_OPTIONS;
    activeFilters: Filter[];
    setActiveFilters: (filters: Filter[]) => void;
    setTotal: (number) => void;
    activePage: number;
    refresh?: () => void;
}

/**
 * Component for filtering mobile devices
 * Modernized to use a fully functional approach without Redux
 */
export const MobileDevicesFilters: React.FC<Props> = ({ sortOptions, activeFilters, setActiveFilters, refresh }) => {
    useEffect(() => {
        const statusesOptions = Object.values(MobileDeviceStatuses).map((status) => ({
            label: startCase(status),
            value: status,
        }));

        const apkTypeOptions = Object.values(ApkType).map((type) => ({
            label: startCase(type),
            value: type,
        }));

        setActiveFilters([
            new NumberFilter('Mobile Device ID', 'id', null),
            new TextFilter('Hardware ID', 'imei', ''),
            new MultiSelectFilter('APK Type', 'apkType', [], apkTypeOptions, null, false),
            new TextFilter('Outlet', 'outlet', ''),
            new MultiSelectFilter('Status', 'status', [], statusesOptions, null, false),
        ]);
    }, []);

    useEffect(() => {
        if (activeFilters.length > 0 && refresh) {
            refresh();
        }
    }, [activeFilters, sortOptions, refresh]);

    const filterChangedHandler = (filters: Filter[]) => {
        setActiveFilters(filters);
    };

    return (
        <FiltersComponent
            defaultFilters={activeFilters}
            disableRemove
            filters={activeFilters}
            onApplyFilters={filterChangedHandler}
            withApply
            withIsSelected
        />
    );
};
